export enum CompanyType {
    ADMIN = 'admin',
    AUDITOR = 'auditor',
    DENTIST = 'dentist',
    LABORATORY = 'laboratory',
}
